import { Loader, Modal } from '@oy/uidesktop';
import { pdfjs } from 'react-pdf';
import { IS_DANARAPAY } from 'src/constants';
import styles from './SignLegalDocumentModal.module.css';
import {
  AlreadySignedModal,
  CloseModalConfirmation,
  EmailNotOpenModal,
  SuccessModal,
} from './components/ConfirmationModal';
import { ListDocument } from './components/ListDocument/ListDocument';
import { PreviewDocument } from './components/PreviewDocument/PreviewDocument';
import { SignLegalDocumentFooter } from './components/SignLegalDocumentFooter/SignLegalDocumentFooter';
import { SignLegalDocumentModalHeader } from './components/SignLegalDocumentModalHeader/SignLegalDocumentModalHeader';
import { SignLegalDocumentModalContext } from './useSignLegalDocumentModalContext';
import { useSignLegalDocumentModalImpl } from './useSignLegalDocumentModalImpl';

pdfjs.GlobalWorkerOptions.workerSrc =
  'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.12.313/pdf.worker.js';

export const SignLegalDocumentModal = () => {
  const {
    state,
    onCloseModal,
    onCloseModalConfirmation,
    onCancelCloseModalConfirmation,
    onCloseModalSuccess,
    onSubmit,
    onAddSignedDocument,
    onCloseAlreadySigned,
    onBackToAllDocument,
    onDownload,
    onClickReadDocument,
    setRef,
    onChangeAgreementNumber,
    resetPosition,
    onCloseModalEmailDidntOpen,
    setShowModalEmailDidntOpen,
  } = useSignLegalDocumentModalImpl();
  const {
    show,
    isBottom,
    legalDocs,
    showCloseModal,
    showSuccessModal,
    isLoading,
    payloadToSignDocuments,
    isSubmitting,
    isAlreadySigned,
    selectedDocument,
    agreementNumber,
    showModalEmailDidntOpen,
  } = state;
  if (IS_DANARAPAY) return null;
  return (
    <SignLegalDocumentModalContext.Provider
      value={{
        selectedDocument,
        agreementNumber,
        isBottom,
        allDocument: legalDocs,
        payloadToSignDocuments,
        onAddSignedDocument,
        onChangeAgreementNumber,
        setRef,
        onSubmit,
        resetPosition,
      }}
    >
      {isSubmitting && <Loader isUsingBackdrop />}
      <Modal
        className={styles.modalContainer}
        show={show}
        onClose={onCloseModal}
      >
        <Modal.Body className={styles.modalBody}>
          <SignLegalDocumentModalHeader
            selectedDocument={selectedDocument}
            onClose={onCloseModal}
            onBackToAllDocument={onBackToAllDocument}
          />
          <div className={styles.contentContainer}>
            {isLoading && <Loader isUsingBackdrop />}
            {!selectedDocument && (
              <ListDocument
                onDownload={onDownload}
                onClickReadDocument={onClickReadDocument}
                setShowModalEmailDidntOpen={setShowModalEmailDidntOpen}
              />
            )}
            {selectedDocument && <PreviewDocument />}
          </div>
          <SignLegalDocumentFooter />
        </Modal.Body>
      </Modal>
      <CloseModalConfirmation
        showCloseModal={showCloseModal}
        onCancelCloseModalConfirmation={onCancelCloseModalConfirmation}
        onCloseModalConfirmation={onCloseModalConfirmation}
      />
      <AlreadySignedModal
        showModal={isAlreadySigned}
        onCloseModal={onCloseAlreadySigned}
      />
      <SuccessModal
        showSuccessModal={showSuccessModal}
        onCloseModalConfirmation={onCloseModalSuccess}
      />
      <EmailNotOpenModal
        showEmailNotOpenModal={showModalEmailDidntOpen}
        onCloseModalConfirmation={onCloseModalEmailDidntOpen}
      />
    </SignLegalDocumentModalContext.Provider>
  );
};
